module.exports = (__parcel__import__("6wEtT")).then(() => parcelRequire('kKorg'));